module.exports = __webpack_public_path__ + "static/media/banos.f8d2c265.png";